export const FORMATS = {
  dateTimeLocalSeconds: "yyyy-MM-dd'T'HH:mm:ssXXX",
};
